// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/orgoverview/overview.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canGetCachedOverview } from "./check";

export function useCanGetCachedOverview(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canGetCachedOverview(withinScope);
  return canDoAction;
}
